import { render } from "./BlogCover.vue?vue&type=template&id=52a3aab4&scoped=true"
import script from "./BlogCover.vue?vue&type=script&lang=js"
export * from "./BlogCover.vue?vue&type=script&lang=js"

import "./BlogCover.vue?vue&type=style&index=0&id=52a3aab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.6.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a3aab4"]])

export default __exports__